'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const defaultEncodingConfig = {
    keyValueDelimiter: ':',
    pairDelimiter: '+',
};
const encodeSearchValue = (searchValue, config = defaultEncodingConfig) => {
    const { pairDelimiter, keyValueDelimiter } = config;
    return Object.entries(searchValue)
        .map(([key, value]) => {
        const stringValue = Array.isArray(value) ? value.join(',') : value;
        return `${key}${keyValueDelimiter}${encodeURI(stringValue)}`;
    })
        .join(pairDelimiter);
};
const encodeSearchObject = (searchObject) => {
    const { sort, query, offset, limit } = searchObject;
    const sortEncoded = sort ? encodeSearchValue(sort) : null;
    const queryEncoded = query ? encodeSearchValue(query) : null;
    const urlParams = new URLSearchParams(Object.assign(Object.assign({}, (offset !== undefined ? { offset: offset.toString() } : undefined)), (limit !== undefined ? { limit: limit.toString() } : undefined)));
    if (sortEncoded)
        urlParams.append('sort', sortEncoded);
    if (queryEncoded)
        urlParams.append('query', queryEncoded);
    return urlParams.toString();
};

exports.encodeSearchObject = encodeSearchObject;
exports.encodeSearchValue = encodeSearchValue;
//# sourceMappingURL=encode-search-object.js.map
